export default "__VITE_ASSET__cpT1tRlp__"